import { tokens } from '../../theme';

export const adminTokens = {
  bg: tokens.bg,
  panel: 'rgba(14, 23, 18, 0.94)',
  panelSoft: 'rgba(18, 29, 23, 0.86)',
  border: 'rgba(197, 215, 152, 0.15)',
  borderStrong: 'rgba(197, 215, 152, 0.28)',
  drawerWidth: 228,
  desktopZoom: 0.84,
  editorialSerif: '"Iowan Old Style", "Palatino Linotype", "Book Antiqua", Georgia, serif',
};

export const caseTone = {
  critical: '#e67c73',
  high: '#d49163',
  medium: '#c7c269',
  low: '#8eb37e',
  open: '#7bc48e',
  review: '#d0b47e',
  risk: '#e67c73',
};

export function panelSx(extra = {}) {
  return {
    backgroundColor: adminTokens.panel,
    borderRadius: 0,
    border: `1px solid ${adminTokens.border}`,
    ...extra,
  };
}

export function formatCompactDate(value) {
  if (!value) return '—';
  return new Date(value).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function formatRelativeTime(value) {
  if (!value) return '—';
  const diff = Date.now() - new Date(value).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${Math.max(1, mins)}m`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  return `${days}d`;
}

export function formatRelativeTimeLong(value) {
  if (!value) return '—';
  const diff = Date.now() - new Date(value).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${Math.max(1, mins)} min ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} day${days === 1 ? '' : 's'} ago`;
  const months = Math.floor(days / 30);
  return `${months} month${months === 1 ? '' : 's'} ago`;
}

export function formatCaseCreatedAt(value) {
  if (!value) return '—';
  const date = new Date(value);
  const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
  const rest = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  return `Created ${weekday} ${rest}, ${time} PT`;
}

export function formatMessageTime(value) {
  if (!value) return '';
  const date = new Date(value);
  const now = new Date();
  const isToday = date.toDateString() === now.toDateString();
  if (isToday) return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export function formatDisplayCaseId(createdAt, rawId) {
  const date = createdAt ? new Date(createdAt) : new Date();
  const year = date.getFullYear();
  const stamp = `${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}`;
  const suffix = String(rawId || '').replace(/\D/g, '').slice(-2).padStart(2, '0');
  return `CASE-${year}-${stamp}${suffix}`;
}
